

































import { Component } from "vue-property-decorator";
import Vue from "vue";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { pusher } from "@/services/PusherClient";
import CobaPasienList from "./CobaPasienList.vue";
import moment from "moment";
import DataSosialPasienCard from "@/pages/DaftarPasienPage/DataSosialPasienCard.vue";
import DataObject from "@/utility/DataObject";
import DataPasien from "@/services/DataPasien";
import { storePasien } from "@/store/modules/pasien";
import { IGD_STATUS_FILTER_OPTIONS } from "@/constants/igdStatus";
import { storeDokter } from "@/store/modules/dokter";
import { storeSoap } from "@/store/modules/soap";
import { storeCopy } from "@/store/modules/copy";
import CardListPasien from "../DaftarPasienPage/CardListPasien.vue";

@Component({
  components: {
    CardListPasien,
    CobaPasienList,
    DataSosialPasienCard
  },
  beforeRouteLeave(to, from, next) {
    pusher.unsubscribe(`pemeriksaan.unit.${this.sess_login["unit_id"]}`);

    next();
  }
})
export default class DaftarPasienIGD extends Vue {
  data: any = DataObject.dataSosial;
  cm = "";
  pasien: Array<object> = [];
  hdn = "";
  btn = "";
  loading = true;
  loadingList = false;
  showFilterDokter = true;
  errListPx = "0";
  errPx = "0";
  reg = "";
  sess_login = this.stateuser;
  today = new Date().toISOString().substr(0, 10);
  tanggal = this.today;

  loadingDataPasien = false;
  status: Array<object> = IGD_STATUS_FILTER_OPTIONS;
  loadingRmPasien = "";
  listPasienCardHeight = "700";

  mounted() {
    appModule.setLoading(true);
    if (!storeDokter.listOnKlinik.length) {
      this.getDokterByUnit(this.stateuser.unit_id);
    }
  }

  getDokterByUnit(kdPoli) {
    storeDokter.act_on_unit(kdPoli);
    storeDokter.act_dokter_all();
  }
  get listDokter() {
    return storeDokter.list;
  }

  get stateuser() {
    return userModule.user;
  }
  get showLoading() {
    return appModule.loading;
  }

  get pasienListIgd() {
    return this.pasien.length
      ? this.pasien.map(function(item: any) {
          const plgDate = [null, "2021-12-24 23:00:05", "2021-12-25 02:03:04"],
            statusPenerimaan = [null, "Diterima", "Batal periksa", "Selesai"],
            plg = plgDate[Math.floor(Math.random() * plgDate.length)],
            status =
              statusPenerimaan[
                Math.floor(Math.random() * statusPenerimaan.length)
              ];

          return {
            ...item,
            tgl_in: moment(item.tgl_in, "DD-MM-YYYY").format("YYYY-MM-DD"),
            tgl_out: moment(item.tgl_out, "DD-MM-YYYY").format("YYYY-MM-DD"),
            dipulangkanAt: plg,
            status: status
          };
        })
      : [];
  }

  /* GetPasien() {
    const dt = DataList.getListPasienUnit(this.sess_login["unit_id"]);
    dt.then(dt => {
      appModule.setLoading(false);
      if (dt["status"] != 1) {
        this.errListPx = "1";
        // appModule.NoticeDelayAlert(dt.err);
        // appModule.sendErrorAlert(dt["err"]);
      } else {
        this.pasien = dt.data;
        //   this.btn = "hidden";
        this.hdn = "";
        // console.log(this.pasien);
      }
    }).finally(() => {
      this.loading = false;
    });
  } */

  triggerGetList(params) {
    this.tanggal = params.date;

    // this.getListPasien();
  }

  addSoap(val) {
    const dt = DataPasien.getDataPasienLastReg(val["rm"]);
    dt.then(dt => {
      // console.log(dt);
      if (dt["status"] != 1) {
        // appModule.sendErrorAlert(dt["err"]);
      } else {
        storeCopy.clear_copy_all();
        storeSoap.act_clear_ctt();
        this.$router.push({
          name: `pemeriksaan`,
          params: {
            register: val["register"],
            rm: val["rm"],
            page: val["page"]
            // rm: this.data["pasien"].rm,
          }
        });
      }
    });
  }

  async dataPasien(value) {
    console.log("get data pasien", value);
    this.errPx = "0";
    // console.log("val", value["item"]);
    // console.log("loaded", value["item"].loaded);
    // value["item"].loading2 = true;
    this.data = DataObject.dataSosial;
    this.hdn = "";
    this.btn = "hidden";
    appModule.setLoading(true);
    this.loadingDataPasien = true;

    DataPasien.getDetailPemeriksaan(value["item"].register_id)
      .then(dt => {
        appModule.setLoading(false);
        console.log("get data pasien response", dt);
        if (dt["status"] != 1) {
          // appModule.NoticeDelayAlert(dt.err);
          this.errPx = "1";
          this.reg = value["item"].register_id;
          // appModule.sendErrorAlert(dt["err"]);
        } else {
          this.data = dt.data;
          this.btn = "";
          // this.cm = value.item.pasien.rm;
          this.hdn = "1";
          // this.loading2 = value["item"].loaded;

          const pasien = { ...dt["data"].alergi };
          pasien.alergi = dt["data"].alergi;

          storePasien.setRegisterPasien({
            register: dt.data.register, // eslint-disable-line
            pasien: pasien
          });
          storePasien.setPasien(pasien);

          storePasien.act_pasien(value.item.rm);
        }
      })
      .finally(() => {
        this.loadingDataPasien = false;
      });
  }

  reloadListPx() {
    this.errListPx = "0";
    // this.getListPasien();
  }
}
